import type { AxiosError } from 'axios'
import type { RouterHook } from '@/types/router/router-hook.type'
import { getCurrentUser } from '@/services/api/users.api'
import { useUserStore } from '@/stores/user.store'
import { isEmpty } from '@/utils/object/is-empty'

export const setupHook: RouterHook = {
  beforeEachAuthenticated: async (to) => {
    const settings = {
      user: false,
      organisation: false,
      ...(to.meta as any).setup,
    }

    if (!settings.user && !settings.organisation)
      return

    const userStore = useUserStore()

    if (settings.user && isEmpty(userStore.user)) {
      const user = await getCurrentUser().catch(async (err: AxiosError) => {
        if (err.response?.status === 404) {
          await userStore.userLogOut()
        }
      })

      if (user) {
        userStore.setUser(user)
      }
    }

    if (settings.organisation) {
      userStore.restoreSelectedOrganisation()
    }
  },
}
